class FFBeersList extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ffRendered === 'true') return;

    const wrapper = this.closest('[data-ff-beers-wrapper]');
    const raw = this.dataset.ffBeersJson;

    if (!raw) {
      this.hideWrapper(wrapper);
      return;
    }

    let beers;
    try {
      beers = JSON.parse(raw);
    } catch (err) {
      console.error('ff-beers-list: invalid JSON', err);
      this.hideWrapper(wrapper);
      return;
    }

    const text = Array.isArray(beers)
      ? beers
          .filter((beer) => beer && typeof beer === 'object' && beer.nombre)
          .map((beer) => `${beer.qty ?? ''} ${beer.nombre}`.trim())
          .filter(Boolean)
          .join(', ')
      : '';

    if (!text) {
      this.hideWrapper(wrapper);
      return;
    }

    this.textContent = text;
    this.dataset.ffRendered = 'true';
  }

  hideWrapper(wrapper) {
    if (wrapper) {
      wrapper.remove();
    } else {
      this.remove();
    }
  }
}

if (!customElements.get('ff-beers-list')) {
  customElements.define('ff-beers-list', FFBeersList);
}
